import { Radio, Space } from 'antd';
import { RelPermChartProps } from '../../../../../@types/kr/types';
import { useTheme } from '../../../../../providers/theme';
import { getColors } from '../../../../utils/getColors';
import { AxisTypeValue, SeriesOptionsType } from 'highcharts';
import { useMemo, useState } from 'react';
import { useAppContext } from '../../../../../providers/AppContext';
import { Chart } from '../../../../chart/BaseChart';
import { ChartSpec } from '../../../../chart/chartSpec';

const AnalysisChart = (props: RelPermChartProps) => {
  const { isDay } = useTheme();
  const { configStates } = useAppContext();
  const colors = getColors(isDay);
  const [yAxisType, setYAxisType] = useState<AxisTypeValue>('linear');

  const handleAxisChange = (value: AxisTypeValue) => {
    setYAxisType(value);
  };

  const spec: ChartSpec = useMemo(() => ({
    title: 'Kr x Sw',
    xAxis: { title: 'Water Saturation, Sw' },
    yAxis: { title: 'Relative Permeability, Kr', type: yAxisType, max: 1 },
    series: props.data as SeriesOptionsType[]
  }), [yAxisType, props.data]);

  return (
    <div style={{ marginLeft: '0.5rem' }}>
      {configStates.showKrTable && (
        <Space
          direction="vertical"
          style={{
            backgroundColor: 'transparent',
            border: `1px solid ${colors.border}`,
            borderRadius: '16px',
            transition: 'width 0.5s',
            width: '100%'
          }}
        >
          <Space style={{ display: 'block' }}>
            <div style={{ borderBottom: `1px dashed ${colors.border}` }}>
              <div
                style={{
                  display: 'flex',
                  padding: '0.75rem',
                  justifyContent: 'space-between'
                }}
              >
                <Radio.Group
                  onChange={e => handleAxisChange(e.target.value)}
                  options={[
                    { label: 'Linear', value: 'linear' },
                    { label: 'Logarithmic', value: 'logarithmic' }
                  ]}
                  defaultValue={'linear'}
                  style={{
                    width: '100%',
                    backgroundColor: 'transparent !important'
                  }}
                  block
                  optionType="button"
                  buttonStyle="solid"
                  className={isDay ? 'day-radio' : 'night-radio'}
                />
              </div>
            </div>
            <div style={{ padding: '0.75rem' }}>
              <Chart spec={spec} />
            </div>
          </Space>
        </Space>
      )}
    </div>
  );
};

export default AnalysisChart;
